import { createBrowserRouter } from "react-router";

export const RouterPublic = createBrowserRouter([
	{
		path: "cookies",
		lazy: () => import("../routes/cookies._index/route"),
	},
	{
		path: "impressum",
		lazy: () => import("../routes/impressum._index/route"),
	},
	{
		path: "privacy",
		lazy: () => import("../routes/privacy._index/route"),
	},
	{
		path: "sso-callback",
		lazy: () => import("../routes/sso-callback"),
	},
	{
		path: "terms",
		lazy: () => import("../routes/terms._index/route"),
	},
	{
		path: "*",
		lazy: () => import("../routes/signin"),
	},
]);
